import { FRAMELESS_GRID_CELL_SIZE_M } from "../configuratorConstants";
import { distance } from "../configuratorUtils";

export const calculateFramelessPartitionSegments = (partition) => {
  if (!partition) {
    return [];
  }

  const startPoint = partition.startPoint || { x: 0, y: 0 };
  const endPoint = partition.endPoint || { x: 0, y: 0 };

  const rawLength = distance(startPoint, endPoint);
  const hasLength = rawLength > 0;

  const segmentCount = hasLength
    ? Math.max(1, Math.round(rawLength / FRAMELESS_GRID_CELL_SIZE_M))
    : 1;

  const normalizedLength = hasLength
    ? rawLength / segmentCount
    : FRAMELESS_GRID_CELL_SIZE_M;

  const elementsArray = Array.isArray(partition.elements)
    ? partition.elements
    : [];

  const segmentsElements = Array.from({ length: segmentCount }, () => []);

  elementsArray.forEach((element) => {
    const position = element.positionOnSegment ?? 0.5;
    const clampedPosition = Math.max(0, Math.min(1, position));
    const index = Math.min(
      segmentCount - 1,
      Math.max(0, Math.floor(clampedPosition * segmentCount)),
    );
    segmentsElements[index].push(element);
  });

  return segmentsElements.map((segmentElements, idx) => ({
    id: `${partition.id}_segment_${idx}`,
    start: idx * normalizedLength,
    length: normalizedLength,
    elements: segmentElements,
  }));
};


